import { render, staticRenderFns } from "./LeaderBoard.vue?vue&type=template&id=9a4feb84&scoped=true"
import script from "./LeaderBoard.vue?vue&type=script&lang=js"
export * from "./LeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoard.vue?vue&type=style&index=0&id=9a4feb84&prod&lang=css"
import style1 from "./LeaderBoard.vue?vue&type=style&index=1&id=9a4feb84&prod&lang=scss&scoped=true"
import style2 from "./LeaderBoard.vue?vue&type=style&index=2&id=9a4feb84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4feb84",
  null
  
)

export default component.exports